import VisibilityIcon from '@material-ui/icons/Visibility';

const ShowIcon = VisibilityIcon;

export default ShowIcon;